import script from "./ClientList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientList.vue?vue&type=script&setup=true&lang=ts"

import "./ClientList.vue?vue&type=style&index=0&id=48077b8d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48077b8d"]])

export default __exports__
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QField});
